// extracted by mini-css-extract-plugin
module.exports = {"my-shop-receiver-container":"MyShopReceiverPage_my-shop-receiver-container__E2u6c"};